var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "card",
    style: _vm.cssVars,
    attrs: {
      "elevation": "1"
    }
  }, [_c('v-card-title', {
    staticClass: "d-flex justify-space-between accent--text pb-4"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("Предпросмотр документа")]), _c('span', [_c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "title": "Уменьшить масштаб"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('v-icon', [_vm._v(" mdi-magnify-minus-outline ")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "title": "Увеличить масштаб"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('v-icon', [_vm._v(" mdi-magnify-plus-outline ")])], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": "",
      "title": "Распечатать документ"
    },
    on: {
      "click": _vm.printDoc
    }
  }, [_c('v-icon', [_vm._v(" mdi-printer ")])], 1)], 1)]), _c('v-card-text', [_vm.file ? _c('div', {
    staticClass: "canvas_container"
  }, [_c('canvas', {
    ref: "pdfRenderer"
  })]) : _c('div', {
    staticClass: "no-content"
  }, [_c('v-icon', {
    attrs: {
      "size": "80"
    }
  }, [_vm._v(" mdi-cat ")])], 1), _vm.file ? _c('div', {
    staticClass: "d-flex justify-center"
  }, [_c('div', {
    staticClass: "d-flex align-center mt-2"
  }, [_c('v-icon', {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.fileState.currentPage === 1,
      "color": "lightGrey",
      "title": "Предыдущая страница"
    },
    on: {
      "click": _vm.goPrevious
    }
  }, [_vm._v(" mdi-chevron-left ")]), _c('span', {
    staticClass: "accent--text page-info"
  }, [_vm._v(" Страница " + _vm._s(_vm.fileState.currentPage) + " из " + _vm._s(_vm.fileState.totalPages) + " ")]), _c('v-icon', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.fileState.currentPage === _vm.fileState.totalPages,
      "color": "lightGrey",
      "title": "Следующая страница"
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v(" mdi-chevron-right ")])], 1)]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }